// src/main.js

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import api from './axios';


const app = createApp(App);

app.config.globalProperties.$api = api;

// Create Pinia store
const pinia = createPinia();
app.use(pinia);

// Use router
app.use(router);

// Mount the app
app.mount('#app');
